<div id="chartContainer" style="position: relative; height: 400px;">
  <canvas baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [plugins]="barChartPlugins"
    [type]="barChartType">
  </canvas>
</div>